/** Get Dashboard Chart data */
export const API_SUCCESS = "API_SUCCESS";
export const API_FAIL = "API_FAIL";
export const GET_CHARTS_DATA = "GET_CHARTS_DATA";
export const GET_TODO = "GET_TODO";
export const GET_TODO_SUCCESS = "GET_TODO_SUCCESS";
export const GET_TODO_FAIL = "GET_TODO_FAIL";
export const GET_PROFILE = "GET_PROFILE";
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
export const GET_PROFILE_FAIL = "GET_PROFILE_FAIL";
export const GET_SCORES = "GET_SCORES";
export const GET_SCORES_SUCCESS = "GET_SCORES_SUCCESS";
export const GET_SCORES_FAIL = "GET_SCORES_FAIL";
export const GET_MASTER_RESOURCES = "GET_MASTER_RESOURCES";
export const GET_MASTER_RESOURCES_SUCCESS = "GET_MASTER_RESOURCES_SUCCESS";
export const GET_MASTER_RESOURCES_FAIL = "GET_MASTER_RESOURCES_FAIL";
export const GET_MASTER_NOTIFICATION_CHANNELS = "GET_MASTER_NOTIFICATION_CHANNELS";
export const GET_MASTER_NOTIFICATION_CHANNELS_SUCCESS = "GET_MASTER_NOTIFICATION_CHANNELS_SUCCESS";
export const GET_MASTER_NOTIFICATION_CHANNELS_FAIL = "GET_MASTER_NOTIFICATION_CHANNELS_FAIL";
export const GET_AWS_REFRESH = "GET_AWS_REFRESH";
export const GET_AWS_REFRESH_SUCCESS = "GET_AWS_REFRESH_SUCCESS";
export const GET_AWS_REFRESH_FAIL = "GET_AWS_REFRESH_FAIL";
export const GET_MISSING_ALERTS = "GET_MISSING_ALERTS";
export const GET_MISSING_ALERTS_SUCCESS = "GET_MISSING_ALERTS_SUCCESS";
export const GET_MISSING_ALERTS_FAIL = "GET_MISSING_ALERTS_FAIL";
export const GET_MASTER_SYSTEMS = "GET_MASTER_SYSTEMS";
export const GET_MASTER_SYSTEMS_SUCCESS = "GET_MASTER_SYSTEMS_SUCCESS";
export const GET_MASTER_SYSTEMS_FAIL = "GET_MASTER_RESOURCES_FAIL";
export const GET_CLOUD_DETAILS = "GET_CLOUD_DETAILS";
export const GET_CLOUD_DETAILS_SUCCESS = "GET_CLOUD_DETAILS_SUCCESS";
export const GET_CLOUD_DETAILS_FAIL = "GET_CLOUD_DETAILS_FAIL";
export const GET_NOTIFICATION_CHANNELS = "GET_NOTIFICATION_CHANNELS";
export const GET_NOTIFICATION_CHANNELS_SUCCESS = "GET_NOTIFICATION_CHANNELS_SUCCESS";
export const GET_NOTIFICATION_CHANNELS_FAIL = "GET_NOTIFICATION_CHANNELS_FAIL";
export const GET_COMPLETED_ALERTS = "GET_COMPLETED_ALERTS";
export const GET_COMPLETED_ALERTS_SUCCESS = "GET_COMPLETED_ALERTS_SUCCESS";
export const GET_COMPLETED_ALERTS_FAIL = "GET_COMPLETED_ALERTS_FAIL";
export const GET_NEW_RELIC_RESOURCES = "GET_NEW_RELIC_RESOURCES";
export const GET_NEW_RELIC_RESOURCES_SUCCESS = "GET_NEW_RELIC_RESOURCES_SUCCESS";
export const GET_NEW_RELIC_RESOURCES_FAIL = "GET_NEW_RELIC_RESOURCES_FAIL";
export const GET_MONITORING_SYSTEMS = "GET_MONITORING_SYSTEMS";
export const GET_MONITORING_SYSTEMS_SUCCESS = "GET_MONITORING_SYSTEMS_SUCCESS";
export const GET_MONITORING_SYSTEMS_FAIL = "GET_MONITORING_SYSTEMS_FAIL";
export const GET_NEWRELIC_MISSING_ALERTS = "GET_NEWRELIC_MISSING_ALERTS";
export const GET_NEWRELIC_MISSING_ALERTS_SUCCESS = "GET_NEWRELIC_MISSING_ALERTS_SUCCESS";
export const GET_NEWRELIC_MISSING_ALERTS_FAIL = "GET_NEWRELIC_MISSING_ALERTS_FAIL";
export const GET_NEWRELIC_METRICS = "GET_NEWRELIC_METRICS";
export const GET_NEWRELIC_METRICS_SUCCESS = "GET_NEWRELIC_METRICS_SUCCESS";
export const GET_NEWRELIC_METRICS_FAIL = "GET_NEWRELIC_METRICS_FAIL";
export const GET_NEWRELIC_DEFAULT_THRESHOLD = "GET_NEWRELIC_DEFAULT_THRESHOLD";
export const GET_NEWRELIC_DEFAULT_THRESHOLD_SUCCESS = "GET_NEWRELIC_DEFAULT_THRESHOLD_SUCCESS";
export const GET_NEWRELIC_DEFAULT_THRESHOLD_FAIL = "GET_NEWRELIC_DEFAULT_THRESHOLD_FAIL";
export const GET_NEWRELIC_DYNAMIC_DEFAULT_THRESHOLD = "GET_NEWRELIC_DYNAMIC_DEFAULT_THRESHOLD";
export const GET_NEWRELIC_DYNAMIC_DEFAULT_THRESHOLD_SUCCESS = "GET_NEWRELIC_DYNAMIC_DEFAULT_THRESHOLD_SUCCESS";
export const GET_NEWRELIC_DYNAMIC_DEFAULT_THRESHOLD_FAIL = "GET_NEWRELIC_DYNAMIC_DEFAULT_THRESHOLD_FAIL";
export const GET_NEW_RELIC_COMPLETED_ALERTS = "GET_NEW_RELIC_COMPLETED_ALERTS";
export const GET_NEW_RELIC_COMPLETED_ALERTS_SUCCESS = "GET_NEW_RELIC_COMPLETED_ALERTS_SUCCESS";
export const GET_NEW_RELIC_COMPLETED_ALERTS_FAIL = "GET_NEW_RELIC_COMPLETED_ALERTS_FAIL";
export const GET_AWS_SCAN = "GET_AWS_SCAN";
export const GET_AWS_SCAN_SUCCESS = "GET_AWS_SCAN_SUCCESS";
export const GET_AWS_SCAN_FAIL = "GET_AWS_SCAN_FAIL";
export const GET_NEWRELIC_REFRESH = "GET_NEWRELIC_REFRESH";
export const GET_NEWRELIC_REFRESH_SUCCESS = "GET_NEWRELIC_REFRESH_SUCCESS";
export const GET_NEWRELIC_REFRESH_FAIL = "GET_NEWRELIC_REFRESH_FAIL";
export const GET_AWS_SCORES = "GET_AWS_SCORES";
export const GET_AWS_SCORES_SUCCESS = "GET_AWS_SCORES_SUCCESS";
export const GET_AWS_SCORES_FAIL = "GET_AWS_SCORES_FAIL";
export const GET_NEWRELIC_SCORES = "GET_NEWRELIC_SCORES";
export const GET_NEWRELIC_SCORES_SUCCESS = "GET_NEWRELIC_SCORES_SUCCESS";
export const GET_NEWRELIC_SCORES_FAIL = "GET_NEWRELIC_SCORES_FAIL";
export const GET_NEWRELIC_SCAN = "GET_NEWRELIC_SCAN";
export const GET_NEWRELIC_SCAN_SUCCESS = "GET_NEWRELIC_SCAN_SUCCESS";
export const GET_NEWRELIC_SCAN_FAIL = "GET_NEWRELIC_SCAN_FAIL";
export const GET_ALL_MISSING_ALERTS = "GET_ALL_MISSING_ALERTS";
export const GET_ALL_MISSING_ALERTS_SUCCESS = "GET_ALL_MISSING_ALERTS_SUCCESS";
export const GET_ALL_MISSING_ALERTS_FAIL = "GET_ALL_MISSING_ALERTS_FAIL";
export const GET_ALCOM_SCORE = "GET_ALCOM_SCORE";
export const GET_ALCOM_SCORE_SUCCESS = "GET_ALCOM_SCORE_SUCCESS";
export const GET_ALCOM_SCORE_FAIL = "GET_ALCOM_SCORE_FAIL";
export const GET_AWS_CHART_DATA = "GET_AWS_CHART_DATA";
export const GET_AWS_CHART_DATA_SUCCESS = "GET_AWS_CHART_DATA_SUCCESS";
export const GET_AWS_CHART_DATA_FAIL = "GET_AWS_CHART_DATA_FAIL";
export const GET_RECENTLY_ADDED_RESOURCES_AWS = "GET_RECENTLY_ADDED_RESOURCES_AWS";
export const GET_RECENTLY_ADDED_RESOURCES_AWS_FAIL = "GET_RECENTLY_ADDED_RESOURCES_AWS_FAIL";
export const GET_RECENTLY_ADDED_RESOURCES_AWS_SUCCESS = "GET_RECENTLY_ADDED_RESOURCES_AWS_SUCCESS";
export const GET_RECENTLY_ADDED_RESOURCES_AZURE = "GET_RECENTLY_ADDED_RESOURCES_AZURE";
export const GET_RECENTLY_ADDED_RESOURCES_AZURE_FAIL = "GET_RECENTLY_ADDED_RESOURCES_AZURE_FAIL";
export const GET_RECENTLY_ADDED_RESOURCES_AZURE_SUCCESS = "GET_RECENTLY_ADDED_RESOURCES_AZURE_SUCCESS";
export const GET_RECENTLY_ADDED_RESOURCES_GCP = "GET_RECENTLY_ADDED_RESOURCES_GCP";
export const GET_RECENTLY_ADDED_RESOURCES_GCP_FAIL = "GET_RECENTLY_ADDED_RESOURCES_GCP FAIL";
export const GET_RECENTLY_ADDED_RESOURCES_GCP_SUCCESS = "GET_RECENTLY_ADDED_RESOURCES_GCP_SUCCESS";
export const GET_RECENTLY_ADDED_RESOURCES_DATADOG = "GET_RECENTLY_ADDED_RESOURCES_DATADOG";
export const GET_RECENTLY_ADDED_RESOURCES_DATADOG_FAIL = "GET_RECENTLY_ADDED_RESOURCES_DATADOG_FAIL";
export const GET_RECENTLY_ADDED_RESOURCES_DATADOG_SUCCESS = "GET_RECENTLY_ADDED_RESOURCES_DATADOG_SUCCESS";
export const GET_RECENTLY_ADDED_RESOURCES_NEWRELIC = "GET_RECENTLY_ADDED_RESOURCES_NEWRELIC";
export const GET_RECENTLY_ADDED_RESOURCES_NEWRELIC_FAIL = "GET_RECENTLY_ADDED_RESOURCES_NEWRELIC_FAIL";
export const GET_RECENTLY_ADDED_RESOURCES_NEWRELIC_SUCCESS = "GET_RECENTLY_ADDED_RESOURCES_NEWRELIC_SUCCESS";
export const GET_RECENTLY_ADDED_RESOURCES_APPDYNAMICS = "GET_RECENTLY_ADDED_RESOURCES_APPDYNAMICS";
export const GET_RECENTLY_ADDED_RESOURCES_APPDYNAMICS_FAIL = "GET_RECENTLY_ADDED_RESOURCES_APPDYNAMICS_FAIL";
export const GET_RECENTLY_ADDED_RESOURCES_APPDYNAMICS_SUCCESS = "GET_RECENTLY_ADDED_RESOURCES_APPDYNAMICS_SUCCESS";
export const GET_RECENTLY_ADDED_RESOURCES_GRAFANA = "GET_RECENTLY_ADDED_RESOURCES_GRAFANA"
export const GET_RECENTLY_ADDED_RESOURCES_GRAFANA_SUCCESS = " GET_RECENTLY_ADDED_RESOURCES_GRAFANA_SUCCESS"
export const GET_RECENTLY_ADDED_RESOURCES_GRAFANA_FAIL = "GET_RECENTLY_ADDED_RESOURCES_GRAFANA_FAIL"
export const GET_RECENTLY_ADDED_RESOURCES_SIGNOZ = "GET_RECENTLY_ADDED_RESOURCES_SIGNOZ"
export const GET_RECENTLY_ADDED_RESOURCES_SIGNOZ_SUCCESS = "GET_RECENTLY_ADDED_RESOURCES_SIGNOZ_SUCCESS"
export const GET_RECENTLY_ADDED_RESOURCES_SIGNOZ_FAIL = "GET_RECENTLY_ADDED_RESOURCES_SIGNOZ_FAIL"
export const GET_RECENTLY_ADDED_RESOURCES_SPLUNK = "GET_RECENTLY_ADDED_RESOURCES_SPLUNK";
export const GET_RECENTLY_ADDED_RESOURCES_SPLUNK_FAIL = "GET_RECENTLY_ADDED_RESOURCES_SPLUNK_FAIL";
export const GET_RECENTLY_ADDED_RESOURCES_SPLUNK_SUCCESS = "GET_RECENTLY_ADDED_RESOURCES_SPLUNK_SUCCESSFUL";
export const GET_ALCOM_SCORE_BY_SERVICE_IDS = "GET_ALCOM_SCORE_BY_SERVICE_IDS";
export const GET_ALCOM_SCORE_BY_SERVICE_IDS_FAIL = "GET_ALCOM_SCORE_BY_SERVICE_IDS_FAIL";
export const GET_ALCOM_SCORE_BY_SERVICE_IDS_SUCCESS = "GET_ALCOM_SCORE_BY_SERVICE_IDS_SUCCESS";
export const GET_RECENTLY_ADDED_RESOURCES_DYNATRACE = "GET_RECENTLY_ADDED_RESOURCES_DYNATRACE";
export const GET_RECENTLY_ADDED_RESOURCES_DYNATRACE_FAIL = "GET_RECENTLY_ADDED_RESOURCES_DYNATRACE_FAIL";
export const GET_RECENTLY_ADDED_RESOURCES_DYNATRACE_SUCCESS = "GET_RECENTLY_ADDED_RESOURCES_DYNATRACE_SUCCESS";
export const GET_RECENTLY_ADDED_RESOURCES_SYNTHETICS = "GET_RECENTLY_ADDED_RESOURCES_SYNTHETICS"
export const GET_RECENTLY_ADDED_RESOURCES_SYNTHETICS_FAIL = "GET_RECENTLY_ADDED_RESOURCES_SYNTHETICS_FAIL"
export const GET_RECENTLY_ADDED_RESOURCES_SYNTHETICS_SUCCESS = "GET_RECENTLY_ADDED_RESOURCES_SYNTHETICS_SUCCESS"
export const GET_RECENTLY_ADDED_RESOURCES_OCI = "GET_RECENTLY_ADDED_RESOURCES_OCI"
export const GET_RECENTLY_ADDED_RESOURCES_OCI_FAIL = "GET_RECENTLY_ADDED_RESOURCES_OCI_FAIL"
export const GET_RECENTLY_ADDED_RESOURCES_OCI_SUCCESS = "GET_RECENTLY_ADDED_RESOURCES_OCI_SUCCESS"

export const GET_MASTER_LOGGING_SYSTEMS = "GET_MASTER_LOGGING_RESOURCES";
export const GET_MASTER_LOGGING_SYSTEMS_SUCCESS = "GET_MASTER_LOGGING_RESOURCES_SUCCESS";
export const GET_MASTER_LOGGING_SYSTEMS_FAIL = "GET_MASTER_LOGGING_RESOURCES_FAIL";

export const GET_LOGGING_SYSTEMS = "GET_LOGGING_RESOURCES";
export const GET_LOGGING_SYSTEMS_SUCCESS = "GET_LOGGING_RESOURCES_SUCCESS";
export const GET_LOGGING_SYSTEMS_FAIL = "GET_LOGGING_RESOURCES_FAIL";
